import React from 'react'
import GatsbyImage from '../gatsby-image'

export default function Image(props) {
    return (
        <GatsbyImage image={props?.node?.image} maxWidth={2500}/>
    )
}